import { useMutation } from '@tanstack/react-query'
import { authService, toAuthUser } from '@/services/auth'
import { useAuthStore } from '@/stores/auth'

interface UseReloginOptions {
  onSuccess?: () => void
  onError?: (message: string) => void
}

export function useRelogin(options?: UseReloginOptions) {
  const setAuth = useAuthStore((s) => s.setAuth)

  return useMutation({
    mutationFn: ({ email, password }: { email: string; password: string }) =>
      authService.login(email, password),

    onSuccess: (response) => {
      setAuth({
        user: toAuthUser(response),
        accessToken: response.access_token,
        refreshToken: response.refresh_token,
      })
      options?.onSuccess?.()
    },

    onError: (error: unknown) => {
      const message =
        error instanceof Error ? error.message : 'E-mail ou senha inválidos.'
      options?.onError?.(message)
    },
  })
}
